import { render, staticRenderFns } from "./Closing.vue?vue&type=template&id=4df0738e"
import script from "./Closing.vue?vue&type=script&lang=js"
export * from "./Closing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports